
class ErrorLogger {
    constructor() {
        window.addEventListener('error', ({ error }) => {
            if (error) {
                this.log(error);
            }
        });
    }

    log(error) {
        const xhr = new XMLHttpRequest();
        const data = JSON.stringify({
            message: error.message,
            callStack: error.stack,
            fileName: error.fileName,
            lineno: error.lineNumber,
            colno: error.colNumber,
            userAgent: window.navigator.userAgent,
            url: window.location.href
        });

        xhr.open('POST', '/error/LogJavaScriptError', true);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.send(data);
    }
}

export default new ErrorLogger();
